import { useContext, useRef } from "react";
import { useOutsideClickHandler } from "../../../../Hooks/useOutsideClick";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../Features/inventoryManagementSlice";
import RowRemoveModal from "./RowRemoveModal";
import { EditSizeChartContext } from "../../../../Context/EditSizeChartContext";

function RowRemoveModalContainer() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);
    const { sizeChartName } = useContext(EditSizeChartContext);

    useOutsideClickHandler(wrapperRef, () => {
        handleCloseModal();
    });

    const handleCloseModal = () => {
        dispatch(closeModal());
    };

    return (
        <div
            ref={wrapperRef}
            className={`w-fit max-w-[60%] bg-white border border-[#EAEAEA] shadow-[0px_0px_12px_0px_#0000003D] rounded-[9px] p-4 flex flex-col gap-4`}
        >
            <div className="w-full flex flex-col gap-3">
                {
                    sizeChartName && 
                    <div className="flex items-center justify-between">
                        <h1 className='font-semibold text-2xl text-[#121212]'>{sizeChartName}</h1>
                    </div>
                }

                <RowRemoveModal />
            </div>
        </div>
    );
}

export default RowRemoveModalContainer;
